import React from 'react'
import PropTypes from 'prop-types'
import { List, ListItem } from 'material-ui/List'
import Subheader from 'material-ui/Subheader'
import Toggle from 'material-ui/Toggle'
import Page from '../common/page/Page'
import Poll from '../../models/Poll'

export default class Settings extends React.Component {
	constructor(props) {
		super(props)

		this.handleToggle = (event, isLoginRequired) => {
			this.props.update({ isLoginRequired })
		}
	}

	componentWillMount() {
		this.props.load()
	}

	render() {
		if (!this.props.poll) {
			return null
		}

		const { poll } = this.props

		return (
			<Page className="settings" title="Settings">
				<List>
					<Subheader>Settings</Subheader>
					<ListItem
						primaryText="Require login to vote"
						rightToggle={
							<Toggle
								onToggle={this.handleToggle}
								toggled={poll.isLoginRequired}
							/>
						}
						secondaryText="Ensures that only people registered can vote"
						secondaryTextLines={2}
					/>
				</List>
			</Page>
		)
	}
}

Settings.propTypes = {
	load: PropTypes.func.isRequired,
	poll: PropTypes.instanceOf(Poll),
	update: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/settings/Settings.jsx